__webpack_require__.p = "/integrations-style-sync/onboarding/";